import React from 'react';
import PropTypes from 'prop-types';
import { previewType } from '../../../Utils';
import Image from './DefaultThumbs/Image';
import Audio from './DefaultThumbs/Audio';
import Default from './DefaultThumbs/Default';
import Video from './DefaultThumbs/Video';
import Text from './DefaultThumbs/Text';
import Pdf from './DefaultThumbs/Pdf';
import Archive from './DefaultThumbs/Archive';

const DefaultThumbnail = ({ previewTypeToCheck = '' }) => {
    switch (previewTypeToCheck) {
        case previewType.IMAGE: {
            return <Image/>;
        }

        case previewType.AUDIO: {
            return <Audio/>;
        }

        case previewType.VIDEO: {
            return <Video/>;
        }

        case previewType.TEXT: {
            return <Text/>;
        }

        case previewType.PDF: {
            return <Pdf/>;
        }

        case previewType.ARCHIVE: {
            return <Archive/>;
        }

        default: {
            return <Default/>;
        }
    }
};

DefaultThumbnail.propTypes = {
    previewTypeToCheck: PropTypes.string
};

class GetThumbnail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldUseDefault: !props.thumbnail
        };
    }

    setShouldUseDefault = () => this.setState({ shouldUseDefault: true });

    render() {
        const {
            shouldUseDefault
        } = this.state;

        const {
            previewType,
            thumbnail
        } = this.props;

        return (
            shouldUseDefault
                ? <DefaultThumbnail previewTypeToCheck={previewType}/>
                : <img src={thumbnail} onError={this.setShouldUseDefault}/>
        );
    }
}

GetThumbnail.propTypes = {
    previewType: PropTypes.string,
    thumbnail: PropTypes.string
};

export default GetThumbnail;
